import { useCrmPermission } from "hooks/useCrmPermission";
import type React from "react";
import { SalesManagementTab } from "routes/crm/SalesBoardPage/components/SalesManagementTab";

/**
 * 営業管理ページ
 * @return {React.ReactElement} 営業管理ページ
 */
export const SalesBoardPage: React.FC = () => {
  const { canEdit, canDelete } = useCrmPermission();

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">営業管理</h1>
      <SalesManagementTab canEdit={canEdit} canDelete={canDelete} />
    </div>
  );
};
